import {Box, Text, Flex, Image} from '@chakra-ui/react'
import {useRef} from 'react'
import Volume from '@assets/svgs/learn/volume.svg'
import Start from '@assets/svgs/learn/star_2.svg'
import {styleByTextTag} from '@utils'

const DetailPhrase = ({
  detailKnowledge,
  handlePlayAudio,
}: {
  detailKnowledge: any
  handlePlayAudio: any
}) => {
  return (
    <Box>
      <Flex
        justifyContent={'space-between'}
        alignItems={'center'}
        gap={'16px'}
        flexDirection={{base: 'column', md: 'row'}}>
        <Flex gap={'16px'}>
          <Flex
            mt={'4px'}
            border={'1px solid #FFC069'}
            borderRadius={'50%'}
            w={'40px'}
            h={'40px'}
            justifyContent={'center'}
            alignItems={'center'}
            flexShrink={0}
            cursor={'pointer'}
            onClick={() => handlePlayAudio(detailKnowledge?.audio)}>
            <Image src={Volume} />
          </Flex>
          <Flex flexDirection={'column'}>
            <Text fontSize={'16px'} color={'#0050B3'} fontWeight={600}>
              {detailKnowledge?.phrase}{' '}
              <span style={{fontSize: '20px'}}>.</span>{' '}
              <span
                style={{
                  fontSize: '13px',
                  fontWeight: 400,
                }}>{`(${detailKnowledge?.part_of_speech})`}</span>
            </Text>
            <Text fontSize={'12px'} fontStyle={'italic'} color={'#8C8C8C'}>
              {detailKnowledge?.ipa}
            </Text>
          </Flex>
        </Flex>
      </Flex>
      <Flex gap={'8px'} mt={'16px'}>
        <Flex
          gap={'8px'}
          flexShrink={0}
          w={'40px'}
          flexDirection={'column'}
          alignItems={'center'}>
          <Image w={'24px'} h={'24px'} src={Start} />
          <Flex border={'1px solid #F0F0F0'} w={'2px'} flex={1}></Flex>
        </Flex>
        <Flex flexDirection={'column'} gap={'8px'}>
          <Text fontSize={'16px'}>Dịch nghĩa</Text>
          {Boolean(detailKnowledge?.meanings.length) &&
            detailKnowledge?.meanings?.map((item: any, index: any) => {
              return (
                <Text key={index} fontSize={'13px'}>
                  {item.word && (
                    <span style={{color: '#8C8C8C'}}>{`[${item.word}] `}</span>
                  )}
                  {item.meaning}
                </Text>
              )
            })}
        </Flex>
      </Flex>
      <Flex gap={'8px'} mt={'16px'}>
        <Flex
          gap={'8px'}
          flexShrink={0}
          w={'40px'}
          flexDirection={'column'}
          alignItems={'center'}>
          <Image w={'24px'} h={'24px'} src={Start} />
          <Flex border={'1px solid #F0F0F0'} w={'2px'} flex={1}></Flex>
        </Flex>
        <Flex flexDirection={'column'} gap={'8px'}>
          <Text fontSize={'16px'}>Ví dụ</Text>
          {Boolean(detailKnowledge?.examples) &&
            detailKnowledge?.examples?.map((item: any, index: any) => {
              return (
                <Box key={index}>
                  <Text fontSize={'13px'}>{styleByTextTag(item.en)}</Text>
                  <Text
                    fontSize={'13px'}
                    fontStyle={'italic'}
                    color={'#8C8C8C'}>
                    {item.vi}
                  </Text>
                </Box>
              )
            })}
        </Flex>
      </Flex>
      <Flex gap={'8px'} mt={'16px'}>
        <Flex
          gap={'8px'}
          flexShrink={0}
          w={'40px'}
          flexDirection={'column'}
          alignItems={'center'}>
          <Image w={'24px'} h={'24px'} src={Start} />
        </Flex>
        <Flex flexDirection={'column'} gap={'8px'}>
          <Text fontSize={'16px'}>Đồng nghĩa</Text>
          <Flex gap={'8px'} wrap={'wrap'}>
            {Boolean(detailKnowledge?.synonyms) &&
              detailKnowledge?.synonyms?.map((item: any, index: any) => {
                return (
                  <Text
                    key={index}
                    fontSize={'13px'}
                    p={'8px 16px'}
                    borderRadius={'100px'}
                    border={'1px solid #91D5FF'}
                    color={'#1890FF'}>
                    {item}
                  </Text>
                )
              })}
          </Flex>
        </Flex>
      </Flex>
    </Box>
  )
}

export default DetailPhrase
